export enum STEPS {
  INITIAL_SETUP,
  PERSONAL_INFORMATION,
  INDENTITY_VERIFICATION,
  SPOUSE_INFORMATION,
  CHILDREN_INFORMATION,
  BANK_INFORMATION,
  PENSION_INFORMATION,
  EMPLOYEE_BENEFIT_INFORMATION,
  STOCK_INFORMATION,
  BOND_INFORMATION,
  PHYSICAL_ASSETS_INFORMATION,
  BENEFICIARY_INFORMATION,
  GUARDIAN_INFORMATION,
  EXECUTOR_INFORMATION,
  TRUSTEE_INFORMATION
}

export const StepPercentage = {
  [STEPS.INITIAL_SETUP]: 1,
  [STEPS.PERSONAL_INFORMATION]: 9,
  [STEPS.INDENTITY_VERIFICATION]: 18,
  [STEPS.SPOUSE_INFORMATION]: 27,
  [STEPS.CHILDREN_INFORMATION]: 36,
  [STEPS.BANK_INFORMATION]: 52,
  [STEPS.PENSION_INFORMATION]: 62,
  [STEPS.EMPLOYEE_BENEFIT_INFORMATION]: 67,
  [STEPS.STOCK_INFORMATION]: 72,
  [STEPS.BOND_INFORMATION]: 77,
  [STEPS.PHYSICAL_ASSETS_INFORMATION]: 80,
  [STEPS.BENEFICIARY_INFORMATION]: 85,
  [STEPS.GUARDIAN_INFORMATION]: 90,
  [STEPS.EXECUTOR_INFORMATION]: 95,
  [STEPS.TRUSTEE_INFORMATION]: 100
};

export const StepPages = {
  [STEPS.INITIAL_SETUP]: 'basic-info',
  [STEPS.PERSONAL_INFORMATION]: 'basic-info',
  [STEPS.INDENTITY_VERIFICATION]: 'identification',
  [STEPS.SPOUSE_INFORMATION]: 'spouse-info',
  [STEPS.CHILDREN_INFORMATION]: 'children-info',
  [STEPS.BANK_INFORMATION]: 'bank-info',
  [STEPS.PENSION_INFORMATION]: 'pension-info',
  [STEPS.EMPLOYEE_BENEFIT_INFORMATION]: 'employee-info',
  [STEPS.STOCK_INFORMATION]: 'stock-share-info',
  [STEPS.BOND_INFORMATION]: 'bond-info',
  [STEPS.PHYSICAL_ASSETS_INFORMATION]: 'physical-asset-info',
  [STEPS.BENEFICIARY_INFORMATION]: 'beneficiary-info',
  [STEPS.GUARDIAN_INFORMATION]: 'guardian-info',
  [STEPS.EXECUTOR_INFORMATION]: 'executor-info',
  [STEPS.TRUSTEE_INFORMATION]: 'trustee-info'
};

export function getStepPercentage(currentStep: STEPS): number {
  return StepPercentage[currentStep];
}

export function getStepPage(currentStep: STEPS): string {
  return StepPages[currentStep];
}
